<!-- Right Sidebar -->
<div class="right-bar" (clickOutside)="hide()" [clickOutsideExclude]="'.right-bar-toggle'">

  <ngx-simplebar class="h-100">

    <div class="rightbar-title px-3 py-4">

      <div class="rightbar-top-bar">
        <a href="javascript:void(0);" class="right-bar-toggle rightbar-close-btn" (click)="hide();">
          <i class="mdi mdi-close"></i>
        </a>
      </div>

      <div class="search-box mb-3">
        <div class="position-relative">
          <input #fileDescription type="text" class="form-control rightbar-search-input rounded" id="buscar"
            name="buscar" placeholder="Buscar" (keydown.enter)="search($event)">
          <i class="mdi mdi-magnify search-icon"></i>
        </div>
      </div>

      <div class="row g-0" *ngIf="this.mostrar == false">
        <ng-container *ngFor="let item of MenuModulo">

          <div class="modulo-section-header">
            <span class="modulo-section-title">{{item.MODULO}}</span>
          </div>

          <ng-container *ngFor="let MENU of item.MENU">
            <div class="col-6 col-sm-4 col-md-3 p-1">
              <div class="menu-icon-card" (click)="Modulo(MENU.S02COD)">
                <div class="menu-icon-wrap">
                  <img [src]="this.URL_ICONO + MENU.S02ICO" alt="{{MENU.S02DES}}">
                </div>
                <span class="menu-icon-label">{{ MENU.S02DES }}</span>
              </div>
            </div>
          </ng-container>

        </ng-container>
      </div>

      <div class="row px-2" *ngIf="this.mostrar == true">
        <ng-container *ngFor="let item of menuItems">
          <ng-container *ngIf="item.OPCIONES != undefined || item.OPCIONES != null">
            <ng-container *ngIf="item.OPCIONES.length > 0 ">

              <div class="search-module-header">
                <i class="mdi mdi-view-grid-plus-outline"></i>
                <span>{{item.S02DES}}</span>
              </div>

              <ng-container *ngFor="let subitem of item.OPCIONES">
                <ng-container *ngIf="subitem.OPCIONES != undefined || subitem.OPCIONES != null">
                  <ng-container *ngIf="subitem.OPCIONES.length > 0">

                    <div class="search-group-title">
                      <span>{{subitem.S13DES}}</span>
                    </div>

                    <div class="search-results-list">
                      <ng-container *ngFor="let titulo of subitem.OPCIONES">
                        <div class="search-result-item" (click)="AbrirMenu(titulo.SYS02CON, titulo.S14DES, titulo.SYS02TIP)">
                          <div class="search-result-item-content">
                            <i class="mdi mdi-circle-medium"></i>
                            <span class="result-text">{{ titulo.S14DES }}</span>
                          </div>
                          <i class="mdi mdi-chevron-right arrow-icon"></i>
                        </div>
                      </ng-container>
                    </div>

                  </ng-container>
                </ng-container>
              </ng-container>

            </ng-container>
          </ng-container>
        </ng-container>
      </div>

    </div>
  </ngx-simplebar>
</div>
<!-- /Right-bar -->

<!-- Right bar overlay-->
<div class="rightbar-overlay"></div>